module.exports = __webpack_public_path__ + "img/noMark.8a00e903.png";